import React from 'react'
import PropTypes from 'prop-types'
import Checkbox from '@material-ui/core/Checkbox'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import { Clock } from 'lucide-react'
import i18n from '../../../assets/i18n'
import InterviewNotesPanelStyled from './styled'

// Notas de la entrevista de la ficha: acciones arriba a la izquierda (mostrar al imprimir y el botón
// de editar, que llega como children), la nota en un panel suave y quién la modificó. Sin título:
// ya lo dice la tab.
const InterviewNotesPanel = ({ noteHtml, author, printNotes, onTogglePrint, children }) => {
  const hasNote = !!(noteHtml && noteHtml.replace(/<[^>]*>/g, '').trim())

  return (
    <InterviewNotesPanelStyled id="interviewer_notes_container" className={printNotes ? 'print' : 'no-print'}>
      <p className={`interview-otes-title-print ${printNotes ? 'print' : 'no-print'}`}>{i18n.interviewerNotes.titleTab}</p>

      <div className="notes-header no-print">
        <div className="notes-actions">
          <FormControlLabel
            className="notes-print"
            control={<Checkbox size="small" checked={printNotes} onClick={onTogglePrint} />}
            label={i18n.interviewerNotes.showOnPrint}
          />
          {children}
        </div>
      </div>

      {hasNote ? (
        <div className="interviewerNote" dangerouslySetInnerHTML={{ __html: noteHtml }} />
      ) : (
        <p className="notes-empty no-print">{i18n.interviewerNotes.empty}</p>
      )}

      {author && (
        <p className="interviewerNote_metadata">
          <Clock size={14} />
          {author}
        </p>
      )}
    </InterviewNotesPanelStyled>
  )
}

InterviewNotesPanel.propTypes = {
  noteHtml: PropTypes.string,
  author: PropTypes.string,
  printNotes: PropTypes.bool,
  onTogglePrint: PropTypes.func,
  children: PropTypes.node
}

export default InterviewNotesPanel
